import React, { useState, useEffect } from 'react';

import {
  createHashRouter,
  createBrowserRouter,
  Route,
  createRoutesFromElements,
  RouterProvider,
  HashRouter,
  createRoutesFromChildren

} from 'react-router-dom';


import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';



//////////////////////// Pages
import Home from './Pages/Home/Home';
import Login from './Pages/Login/Login';
import Clients from './Pages/ClientsPage/Clients';
import HomePageWebsite from './Pages/Website/HomePageWebsite';
import OurServicesWebsite from './Pages/Website/OurServices';
import StatisticsNumber from './Pages/Website/StatisticsNumber';
import Ads from './Pages/Website/Ads';
import News from './Pages/Website/News';
import FAQ from './Pages/Website/FAQ';
import StaticPages from './Pages/Website/StaticPages';
import DescountPage from './Pages/Website/Descount';
import ContactUsPage from './Pages/ContactUs/ContactUs';
import OrderPricing from './Pages/OrderPricing/OrderPricing';
import OtherOrders from './Pages/OtherOrders/OtherOrders';
import Notifications from './Pages/Notifications/Notifications';




/////////>>>> Car Modal
import CarBrand from './Pages/CarPages/CarBrand';
import AddNewModel from './Pages/CarPages/AddNewModel';
import EditModel from './Pages/CarPages/EditModel';
import ImitationModel from './Pages/CarPages/ImitationModel';
import EditAllModelsInBrand from './Pages/CarPages/EditAllModelsInBrand';


/////////>>>> Users
import Users from './Pages/Users/Users';


/////////>>>> Offers
import Offers from './Pages/Offers/Offers';


//////////////// Reports
import ReportsPage from './Pages/Reports/Reports';


///////////////// LayOuts
import MainLayout from './Layouts/MainLayout';
import AuthLayout from './Layouts/AuthLayout';




//////////////////// ForgetPasswrod Pages
import ForgetPasswordEmail from './Pages/ForgetPassword/ForgetPasswordEmail';
import Congratulations from './Pages/ForgetPassword/Congratulations';
import EnterNewPassword from './Pages/ForgetPassword/EnterNewPassword';


import { getHeaderConfig } from './Api/utils';

import './App.css';

const checkHeader = getHeaderConfig()


// {
//   path: "/",
//   element: <Layout />, // Use Layout as the main wrapper
//   errorElement: <ErrorPage />, // Error handling for any invalid routes
//   children: [
//     {
//       path: "/", // This will render inside the <Outlet /> of Layout
//       element: <HomePage />,
//     },
//     {
//       path: "about", // Renders AboutPage inside the Layout
//       element: <AboutPage />,
//     },
//     {
//       path: "contact", // Renders ContactPage inside the Layout
//       element: <ContactPage />,
//     },
//   ],
// },

const router = createHashRouter([
  // <Route path='/' element={<MainLayout />}>
  //   <Route index element={<Home />} /> *
  //   <Route path='/clients' element={<Clients />} /> *
  //   <Route path='/website-homepage' element={<HomePageWebsite />} /> *
  //   <Route path='/website-our-services' element={<OurServicesWebsite />} /> *
  //   <Route path='/website-statistics-number' element={<StatisticsNumber />} /> *
  //   <Route path='/website-ads' element={<Ads />} /> *
  //   <Route path='/website/news' element={<News />} /> *
  //   <Route path='/website/descount' element={<DescountPage />} /> *
  //   <Route path='/website/FAQ' element={<FAQ />} /> * 
  //   <Route path='/website/static-pages' element={<StaticPages />} /> * 
  //   <Route path='/cars' element={<CarBrand />} /> * 
  //   <Route path='/cars/add-new-model' element={<AddNewModel />} /> *
  //   <Route path='/cars/edit-model/:modelId' element={<EditModel />} /> *
  //   <Route path='/cars/imitation-model/:modelImitationModelId' element={<ImitationModel />} /> *
  //   <Route path='/users' element={<Users />} /> *
  //   <Route path='/offers' element={<Offers />} /> * 
  //   <Route path='/reports' element={<ReportsPage />} /> *
  // </Route>
  {
    path: "/",
    element: <MainLayout />,
    children: [
      {
        path: "/",
        element: <Home />,
        // errorElement: <ErrorPage />, // Component to render when there's an error
      },
      {
        path: "/clients",
        element: <Clients />,
      },
      {
        path: "/website-homepage",
        element: <HomePageWebsite />,
      },
      {
        path: "/website-our-services",
        element: <OurServicesWebsite />,
      },
      {
        path: "/website-statistics-number",
        element: <StatisticsNumber />,
      },
      {
        path: "/website-ads",
        element: <Ads />,
      },
      {
        path: "/website/news",
        element: <News />,
      },
      {
        path: "/website/FAQ",
        element: <FAQ />,
      },
      {
        path: "/website/descount",
        element: <DescountPage />,
      },
      {
        path: "/website/static-pages",
        element: <StaticPages />,
      },
      {
        path: "/website/contactUs",
        element: <ContactUsPage />,
      },
      {
        path: "/cars",
        element: <CarBrand />,
      },
      {
        path: "/cars/add-new-model",
        element: <AddNewModel />,
      },
      {
        path: "/cars/edit-model/:modelId",
        element: <EditModel />,
      },
      {
        path: "/cars/imitation-model/:modelImitationModelId",
        element: <ImitationModel />,
      },
      {
        path: "/cars/editAll-models-in-Brand/:editAllModelsInBrandModelId",
        element: <EditAllModelsInBrand />,
      },
      {
        path: "/users",
        element: <Users />,
      },
      {
        path: "/offers",
        element: <Offers />,
      },
      {
        path: "/reports",
        element: <ReportsPage />,
      },

      {
        path: "/OrderPricing",
        element: <OrderPricing />,
      },

      {
        path: "/OtherOrders",
        element: <OtherOrders />,
      },
      {
        path: "/notifications",
        element: <Notifications />,
      },
      

    ]
  },


])

const puplicRouter = createHashRouter([
  {
    path: "/",
    element: <AuthLayout />,
    children: [
      {
        path: "/",
        element: <Login />,
        // errorElement: <ErrorPage />, // Component to render when there's an error
      },
      {
        path: "/forget-password",
        element: <ForgetPasswordEmail />,
      },
      {
        path: "/congratulations",
        element: <Congratulations />,
      },
      {
        path: "/enter-new-password",
        element: <EnterNewPassword />,
      },
    ]
  }
])
//   createRoutesFromElements(
//     <Route path='/' element={<AuthLayout />}> * 
//       <Route index element={<Login />} /> * 
//       <Route path='/forget-password' element={<ForgetPasswordEmail />} /> * 
//       <Route path='/congratulations' element={<Congratulations />} /> * 
//       <Route path='/enter-new-password' element={<EnterNewPassword />} />
//     </Route>
//   )
// )

export default function App() {

  const [logined, setLogined] = useState(false)
  const [isloading, setIsLoading] = useState(true)


  useEffect(() => {
    if (checkHeader.headers.Authorization) {
      setLogined(true)
    } else {
      setLogined(false)
    }
    setIsLoading(false)
  }, [checkHeader])
  if (isloading) {
    return (
      <Box sx={{ display: 'flex', justifyContent:'center', alignItems:'center', width:'100vw', height:'100vh' }}>
        <CircularProgress />
      </Box>
    )
  }

  return (
    <div dir="rtl">

      {logined ? (
        <RouterProvider router={router} />
      ) : (
        <RouterProvider router={puplicRouter} />
      )}
    </div>
  );
}
